import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import './assets/font/iconfont.css'

Vue.config.productionTip = false
Vue.prototype.$baseurl = 'http://www.yaoyangnet.com/volunteer/back'

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
